import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const resetPasswordSchema = z.object({
  token: z.string(),
  password: z.string().min(6, { message: "Password must be at least 6 characters." }),
});

export class ResetPasswordDto extends createZodDto(resetPasswordSchema) {}
